import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useInvoiceTemplatesByService = (serviceUid) => {
    return useQuery({
        queryKey: ['invoice-templates', { serviceUid }],
        queryFn: async () => {
            return await api.getInvoiceTemplatesByService(serviceUid);
        },
        enabled: !!serviceUid,
    });
};

export const useCreateInvoiceTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ serviceUid, data }) => api.createInvoiceTemplate(serviceUid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invoice-templates'] });
        },
    });
};

export const useUpdateInvoiceTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid, data }) => api.updateInvoiceTemplate(uid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invoice-templates'] });
        },
    });
};

export const useDeleteInvoiceTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid }) => api.deleteInvoiceTemplate(uid),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invoice-templates'] });
        },
    });
};
